import * as Sentry from '@sentry/browser'

import {
  Environment,
  SentryConfig
} from '@espoon-voltti/nuora-app-common/config'

import { handleError } from './error-handler'

export * from '@espoon-voltti/nuora-app-common/error-handling/api-error-parser'
export * from './error-handler'

export function init(environment: Environment, config: SentryConfig) {
  Sentry.init({
    dsn: config.dsn,
    enabled: config.enabled,
    environment,
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: false,
        onunhandledrejection: false
      })
    ]
  })

  window.addEventListener('error', (e) => handleError(e.error))
  window.addEventListener('unhandledrejection', (e) => handleError(e.reason))
}
